import React, { Fragment } from "react";
import { Link, useLocation } from "react-router";
import { RouteFactory } from "@app/routePaths";
import { isActiveLink } from "@events-awards/utils/helpers";
import { AwardsMenu } from "@events-awards/utils/types";
import useScrollToCenter from "@hooks/useScrollToCenter";
import { cn } from "@util/helpers";

type EventsAwardsNavigationMenuProps = {
  /** The classname of the navigation menu */
  className?: string;
  /** The data of the navigation menu that will be used to displayed nav items. */
  menuData: AwardsMenu[];
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * Component to render Event and Awards navigation menu
 */
const EventsAwardsNavigationMenu = ({
  className,
  menuData,
}: EventsAwardsNavigationMenuProps): React.ReactElement => {
  const { pathname } = useLocation();
  const { containerRef, targetRef } = useScrollToCenter<
    HTMLUListElement,
    HTMLLIElement
  >(100);

  return (
    <div
      data-testid="events-awards-navigation-menu-component"
      className={cn("mt-6 border-t border-gray-175 py-6", className)}
    >
      <ul ref={containerRef} className="flex flex-row">
        {menuData.map(({ link, text, enabled }) => {
          const isActive = isActiveLink(link, pathname);
          const isEEApplyNowLink = link === RouteFactory.eeApplyNowPage;

          if (!enabled) return <></>;

          return (
            <Fragment key={link}>
              <li
                ref={isActive ? targetRef : null}
                className={cn("flex-shrink-0 px-3 text-center", {
                  "px-0": isEEApplyNowLink,
                })}
              >
                <Link
                  to={link}
                  reloadDocument
                  className={cn(
                    "font-poppins text-lg font-semibold text-gray-850 hover:text-black/70",
                    {
                      "border-b-2 border-gray-850":
                        isActive && !isEEApplyNowLink,
                      "rounded-full bg-gray-850 px-8 py-2 text-base text-white hover:bg-gray-675 hover:text-white":
                        isEEApplyNowLink,
                      "bg-gray-675": isActive && isEEApplyNowLink,
                    }
                  )}
                >
                  {text}
                </Link>
              </li>
            </Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default EventsAwardsNavigationMenu;
